<template>

  <vx-card no-shadow>
   
 
<vs-button class="mb-4" @click="popupActive=true" color="primary" type="border"><i class="fa fa-plus"></i> Adicionar Função</vs-button>
    
    <vs-table stripe  :data="company_roles">


<template slot="header" >

            
          </template>
  <template slot="thead">
    <vs-th>Nome da Função</vs-th>

    <vs-th></vs-th>
  </template>

  <template >
    <vs-tr v-for="item in company_roles" :key="item.id">

     

      <vs-td>
        {{item.name}}
      </vs-td>

      <vs-td><div class="con-btns-user flex items-center justify-end">
                
                <div class="flex">
                  <vs-button type="border" size="small" icon-pack="feather" icon="icon-edit" class="mr-2" @click="openUpdateCargo(item)"></vs-button>
                  <!-- <vs-button type="border" size="small" icon-pack="feather" icon="icon-send" color="success" class="mr-2"></vs-button> -->
                  <vs-button type="border" size="small" icon-pack="feather" icon="icon-trash" color="danger" @click="deleteCompanyRoles(item)"></vs-button>
                </div>
              </div></vs-td>

        <template class="expand-user" slot="expand">
            <div class="con-expand-users w-full">
              
            
                <vs-table :data="item.responsabilities" >


<template slot="header">


            
          </template>
  <template slot="thead">
    <vs-th >Actividades</vs-th>
    <vs-th ></vs-th>
  </template>

  


  <template >
    <vs-tr v-for="option in item.responsabilities" :key="option.id">

     

      <vs-td >
        {{option.name}}
      </vs-td>
<vs-td>
<div class="con-btns-user flex items-center justify-end">
                
                <div class="flex">
                  <vs-button type="border" size="small" icon-pack="feather" icon="icon-edit" class="mr-2" @click="openUpdateActividade(option)"></vs-button>
                  <!-- <vs-button type="border" size="small" icon-pack="feather" icon="icon-send" color="success" class="mr-2"></vs-button> -->
                  <vs-button type="border" size="small" icon-pack="feather" icon="icon-trash" color="danger" @click="deleteActivities(item)" ></vs-button>
                </div>
              </div>
</vs-td>
    </vs-tr>
  </template>
</vs-table>
            </div>
          </template>
    </vs-tr>
  </template>
</vs-table>
<div style="height: 50px;" id="div-with-loading" class="vs-con-loading__container"></div>
    <vs-popup class="holamundo" title="Adicionar Função" :active.sync="popupActive">
          <label class="mt-8" for="">  Nome da Função</label>
      <vs-input class="w-full mt-2 mb-5"  type="text"  v-model="name" />

        <label for="">Actividades</label>
       <div class="vx-row" v-for="(input,k) in responsability_names" :key="k">
          <div class="vx-col sm:w-3/4 w-full mb-2">
            <div class="vx-col w-full">
              <vs-input
                class="w-full"
                icon-pack="feather"
                icon="icon-check"
                icon-no-border
                v-model="input.responsability_name"
              />
            </div>
          </div>
          <div class="vx-col sm:w-1/4 w-full mb-2" vs-align="center">
            <div class="vx-col w-full">
              <!-- <span> -->
                  <vs-button
                  color="danger" 
                 
                    class="mb-2"
                    @click="remove(k)"
                    v-show="k || (!k && responsability_names.length > 1)"
                    >-</vs-button
                  >
                  
                  <vs-button
                  color="success"
                    class=""
                    @click="add(k)"
                    v-show="k == responsability_names.length - 1"
                    >+</vs-button
                  >
                <!-- </span> -->
            </div>
          </div>
        </div>
         
<div class="flex flex-wrap items-center flex-start">
      <vs-button class="ml-auto mt-2" @click="saveData">Salvar</vs-button>
      <vs-button class="ml-4 mt-2" type="border" color="warning">Cancelar</vs-button>

      
    </div>
    </vs-popup>

    <vs-popup class="holamundo" title="Actualizar Função" :active.sync="popupUpdateCargo">
          <label class="mt-8" for="">  Nome da Função</label>
      <vs-input class="w-full mt-2 mb-5"  type="text"  v-model="company_role.name" />

        
         
<div class="flex flex-wrap items-center flex-start">
      <vs-button class="ml-auto mt-2" @click="updateCargo">Actualizar</vs-button>
      <vs-button class="ml-4 mt-2" type="border" color="warning">Cancelar</vs-button>

      
    </div>
    </vs-popup>

    
    <vs-popup class="holamundo" title="Actualizar Actividade" :active.sync="popupUpdateActividade">
          <label class="mt-8" for="">  Nome da Função</label>
      <vs-input class="w-full mt-2 mb-5"  type="text"  v-model="responsability.name" />

        
         
<div class="flex flex-wrap items-center flex-start">
      <vs-button class="ml-auto mt-2" @click="updateActividade">Actualizar</vs-button>
      <vs-button class="ml-4 mt-2" type="border" color="warning">Cancelar</vs-button>

      
    </div>
    </vs-popup>
  </vx-card>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import vSelect from 'vue-select'
import http from "../../../../http-common";

export default {
  components: {
    flatPickr,
    vSelect
  },
  data() {
    return {
        responsabilities:[],
        responsabilidades:[],
        inputs: [{
        name: '',
        party: ''
      }],
      responsability_names: [{
        responsability_name: '',
        
      }],
        name:"",
        responsible_id:"",
departments:[],
employees:[],
selectedEmployee:"",
company_roles:[],
company_role:[
  {
    name:"",
  }
],

responsability:[
  {
    name:"",
    id:"",
  }
],

     
 popupActive: false,
 popupUpdateCargo:false,
 popupUpdateActividade:false,
      // Options
      err:[],
      actividade:[],
    
    }
  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser
    },
    
  },
 mounted() {
    this.initialize();
  },


  methods:{
      initialize() {
      this.getCompanyRoles();
    },

 add () {
      this.responsability_names.push({
        responsability_name: '',
       
      })
      console.log(this.responsability_names)
    },

    remove (index) {
      this.responsability_names.splice(index, 1)
    },

  
    async saveData() {
       this.$vs.loading()
    
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };
      this.responsabilities=this.responsability_names.map(d =>  d.responsability_name)
  
      const data = {
          name:this.name,
          responsability_name: this.responsabilities
          
      };

      this.$validator.validateAll();
      await http
        .post("/companies/companies_role", data, config)
        .then((success) => {
          success;
        this.popupActive=false,
        this.getCompanyRoles(),
          this.$vs.loading.close();
          
          this.$vs.notify({
            title: "Sucesso",
            text: "Categoaria salva com sucesso",
            color: "success",
            position: "top-right",
          })
        })
        .catch((error) => {
          error;
            this.$vs.loading.close();
          if(error.response.status==422 ){
          this.err= error.response.data.message
          this.$vs.notify({
            title: "Erro",
            text: this.err,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          })
          }else{
          this.$vs.notify({
            title: "Erro",
            text: "Aconteceu algum erro",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          })
          }
          
        });
    },
getCompanyRoles() {
  this.$vs.loading({
        container: '#div-with-loading',
        scale: 1.0,
        type:'sound'
      })
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };
      
      http
        .get("/companies/companies_role", config)
        .then((result) => {
          this.$vs.loading.close('#div-with-loading > .con-vs-loading')
          this.company_roles = result.data.Company_roles.reverse()
          this.responsabilidades = result.data.Company_roles[0].responsabilities

          
        })
        .catch((error) => {
          this.$vs.loading.close('#div-with-loading > .con-vs-loading')
          error;
         
        });
    },



    getEmployees() {
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };
      
      http
        .get("/employees", config)
        .then((result) => {
          this.employees = result.data.Employees.reverse();

        })
        .catch((error) => {
          error;
         
        });
    },

       async deleteCompanyRoles(item) {
        this.company_role=item
    this.$vs.loading()
   
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };
  
      

      await http
        .delete(`/companies/companies_role/${this.company_role.id}`, config)
        .then((success) => {
          success;
        
       this.getCompanyRoles();
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Sucesso",
            text: "Eliminado com sucesso",
            color: "success",
            position: "top-right",
          })
        })
 
        .catch((error) => {
          error;
          this.err= error.response.data
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Erro",
            text: this.err,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          })
        });
    },



       async deleteActivities(item) {
        this.company_role=item
    this.$vs.loading()
 
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };
  
      

      this.$validator.validateAll();
      await http
        .delete(`/companies/companies_role/${this.company_role.id}`, config)
        .then((success) => {
          success;
        
       this.getData(),
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Sucesso",
            text: "Eliminado com sucesso",
            color: "success",
            position: "top-right",
          })
        })
 
        .catch((error) => {
          error;
          this.err= error.response.data
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Erro",
            text: this.err,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          })
        });
    },



openUpdateCargo(item){
  this.company_role = item
  this.popupUpdateCargo=true
},
      async updateCargo() {
    this.$vs.loading()

      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };
const data = {
          name:this.company_role.name,
          
      };
      

      this.$validator.validateAll();
      await http
        .put(`/companies/companies_role/${this.company_role.id}`,data, config)
        .then((success) => {
          success;
        this.popupUpdateCargo=false,
       this.getCompanyRoles();
       
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Sucesso",
            text: "Actualizado com sucesso",
            color: "success",
            position: "top-right",
          })
        })
 
        .catch((error) => {
          error;
          this.err= error.response.data
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Erro",
            text: this.err,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          })
        });
    },




    openUpdateActividade(option){
  this.responsability = option
  this.popupUpdateActividade=true
},
      async updateActividade() {
    this.$vs.loading()

      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };
  
  const data = {
          name:this.responsability.name,
          
      };
      

      this.$validator.validateAll();
      await http
        .put(`/companies/responsabilities/${this.responsability.id}`,data, config)
        .then((success) => {
          success;
        this.popupUpdateActividade=false
       this.getCompanyRoles();
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Sucesso",
            text: "Actualizada com sucesso",
            color: "success",
            position: "top-right",
          })
        })
 
        .catch((error) => {
          error;
          this.err= error.response.data
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Erro",
            text: this.err,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          })
        });
    },
  }

}
</script>
